module.exports = __webpack_public_path__ + "img/20180815_151844_206.c1898b3d.jpg";